import React from 'react'
import {Operation} from '../../core/_models'
import {useListView} from '@/components/table/core/ListViewProvider'
import {useIntl} from 'react-intl'
import States from './States'

const ExceptionalOverview = () => {
  const intl = useIntl()
  const {itemForUpdate, setItemForUpdate, setAction} = useListView()

  const op = itemForUpdate as Operation
  const close = () => {
    setAction(undefined)
    setItemForUpdate(undefined)
  }

  return (
    <div>
      <div className='table-responsive'>
        {/* begin::Table */}
        <table className='table align-middle gs-0 gy-5'>
          <tbody>
            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Order ID
              </td>
              <td className='text-start'>
                <span className='badge badge-light-danger fw-semibold me-1'>
                  {op._id}
                </span>
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Date
              </td>
              <td className='text-start'>
                <span className='badge badge-light fw-semibold me-1'>
                  {intl.formatDate(op.date, {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                  })}
                </span>
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                States
              </td>
              <td className='text-start'>
                <States states={op.statuses} scope=""/>
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Reason
              </td>
              <td className='text-start'>
                <b>{op.statuses.at(-1)?.remark}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="pt-15 text-end">
        <button
          type='reset'
          onClick={() => close() }
          className='btn btn-light me-3'
          data-kt-users-modal-action='cancel'
        >
          Close
        </button>
      </div>
    </div>
  )
}

export default ExceptionalOverview
